module.exports = __webpack_public_path__ + "static/media/rank-07-advanced.8f1d6ff6.svg";